var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Cheques"}},[_c('cheque-filter',{on:{"filtersUpdated":_vm.filtersChangeHandler}}),_c('cheque-list',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }